<script setup lang="ts">
// Preserve the shared icon API, with consistent Lucide strokes and accessible names.
import { LayoutDashboard, Network, GitBranch, FileText, Layers, Search, Plus, Minus, ArrowRight, ArrowLeft, Sun, Moon, ChevronRight, ChevronDown, Check, ShieldCheck, Clock, Code, Zap, Play, Pause, Square, SlidersHorizontal, Calendar, ExternalLink, ArrowUpDown, Bell, TriangleAlert, X, RefreshCw, File, Eye, DollarSign, Download, Menu, Sparkles, Link, Target, LogOut, Music, Github, User, MessageSquare, List, Copy, Lock, Cloud, Database, Server, BookOpen, Bot, Boxes, Activity, Plug, Filter, FlaskConical, Globe, Info } from "lucide-vue-next";

const icons = {
  grid: LayoutDashboard,
  map: Network,
  branch: GitBranch,
  brief: FileText,
  layers: Layers,
  search: Search,
  plus: Plus,
  minus: Minus,
  arrow: ArrowRight,
  back: ArrowLeft,
  sun: Sun,
  moon: Moon,
  chevron: ChevronRight,
  down: ChevronDown,
  check: Check,
  shield: ShieldCheck,
  clock: Clock,
  code: Code,
  bolt: Zap,
  play: Play,
  pause: Pause,
  stop: Square,
  settings: SlidersHorizontal,
  calendar: Calendar,
  external: ExternalLink,
  compare: ArrowUpDown,
  bell: Bell,
  warning: TriangleAlert,
  close: X,
  refresh: RefreshCw,
  file: File,
  eye: Eye,
  dollar: DollarSign,
  download: Download,
  menu: Menu,
  sparkle: Sparkles,
  link: Link,
  target: Target,
  logout: LogOut,
  music: Music,
  github: Github,
  user: User,
  message: MessageSquare,
  list: List,
  copy: Copy,
  lock: Lock,
  cloud: Cloud,
  database: Database,
  server: Server,
  book: BookOpen,
  bot: Bot,
  boxes: Boxes,
  pulse: Activity,
  plug: Plug,
  filter: Filter,
  flask: FlaskConical,
  globe: Globe,
  info: Info,
} as const;
export type IconName = keyof typeof icons;
defineProps<{ name: IconName; label?: string; size?: number }>();
</script>

<template>
  <component :is="icons[name]" class="icon" :size="size ?? 18" :stroke-width="1.75"
    :style="size ? { width: `${size}px`, height: `${size}px` } : undefined"
    :role="label ? 'img' : undefined" :aria-label="label" :aria-hidden="label ? undefined : 'true'" />
</template>
